import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

function Header({ logo, headerColor = "#e5ed41" }) {
  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        style={{ backgroundColor: headerColor }}
        data-bs-theme="light"
      >
        <Container fluid>
          <Navbar.Brand href="#home">
            {logo ? (
              <img src={logo} alt="Company Logo" height="40" />
            ) : (
              "Loading..."
            )}
          </Navbar.Brand>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
